module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 4-05685b611efb52013a652eb67d26bd81.jpg";